import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class TestResults270926 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 27/09/2026 Results(Sattahip)</h3>
      <br />
      <br />


        <div><Link to='/conduct-ratchadapornn'>1. AAT 7817  MS.RATCHADAPORN NONNUSAT(Distinction)---Acquired Rank SHODAN-HO***</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>2. ATT  7910  MR.NAPOL PITAYAPAT(Tested at Chula)---Acquired Rank SHODAN-HO***</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>3. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(P)---Acquired Rank 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>4. AAT 7923  MR.THOMAS MOENKEMEIER(P)---Acquired Rank 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>5. AAT 7783  LT.NIRUN CHANTAWARO---NO SHOW</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>6. AAT 7972  CPO1.SUNYA LAEID(P)---Acquired Rank 3KYU***</Link></div>
        <br />
        <div><Link to='/conduct-chakchaia'>7. AAT  8022  1st LT.CHAKCHAI ANUPONGPAT(Distinction)---Acquired Rank 6KYU***</Link></div>
        <br />
        <div><Link to='/conduct-barbarab'>8. AAT 8027  MS.BARBARA BARZARKINA(P)---Acquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-panyasuphak'>9. AAT 8029  MS.PANYASUPHA KHEMARUT(Distinction)---Acquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-nueas'>10. AAT 8006  MS.NUEA SUDRAK(P)---Acquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-zaidena'>11. AAT 8044  MR.ZAIDEN ANDERSSON(P)---Acquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-andrewl'>12. AAT 7973  MR.ANDREW LINDQVIST---NO SHOW</Link></div>
        <br />
        <div><Link to='/conduct-benjaminb'>13. AAT 8045  MR.BENJAMIN BROWN(P)---Acquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-tylerb'>14. AAT 8046  MR.TYLER BROWN(P)---Acquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-wyonab'>15. AAT 8047  MS.WYONA BROWN(P)---Acquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-jaiklal'>16. AAT 8067  MR.JAIKLA LORGUNPAI(Distinction)---Acquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-pittayac'>17. AAT 8077  MR.PITTAYA CHAMNANPOOD(Distinction)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pordeer'>18. AAT 8078  MS.PORDEE RATTANARAK(P)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pemikar'>19. AAT 8079  MS.PEMIKA RATTANA(P)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pattarapony'>20. AAT 8080  MR.PATTARAPON YOUNGHAIPON(P)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-piyanats'>21. AAT 8081  MR.PIYANAT SUPATTHANAKORNKIT(P)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-ratchaninp'>22. AAT 8082  MS.RATCHANIN PEEPANICH(P)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-natnateep'>23. AAT 8083  MR.NATNATEE PEEPANICH(P)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-bowwonlukc'>24. AAT 8084  MS.BOWWONLUK CHAMNANPOOD(P)---Acquired Rank 10KYU</Link></div>
        <br />


        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default TestResults270926;
